module.exports = __webpack_public_path__ + "static/media/user.886b7429.svg";